import { render, staticRenderFns } from "./mapbox.vue?vue&type=template&id=283b2c80&"
import script from "./mapbox.vue?vue&type=script&lang=js&"
export * from "./mapbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports